import { jsx as _jsx } from "react/jsx-runtime";
import { Button as BaseButton } from '@mui/base';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { FoundationContextProvider, SurfaceContextProvider, } from '@clds/design-system-foundations';
import { buttonBlenderMapping } from './blenderMapping.js';
import { ButtonContent } from './ButtonContent.js';
import { buttonStyle } from './buttonStyle.js';
import { useButtonSurface, useFoundation } from './foundationMapping.js';
export const ButtonRoot = styled.button `
  ${buttonBlenderMapping};
  ${buttonStyle};
`;
// eslint-disable-next-line react/display-name
export const Button = forwardRef(({ size, shape = 'normal', variant, tone, leftSlot, rightSlot, children, ...rest }, ref) => {
    const surface = useButtonSurface({ tone, variant });
    const foundation = useFoundation({ size });
    return (_jsx(FoundationContextProvider, { ...foundation.innerContextProps, children: _jsx(SurfaceContextProvider, { ...surface.innerContextProps, children: _jsx(BaseButton, { slots: { root: ButtonRoot }, "data-test": "button", "aria-disabled": rest.disabled, shape: shape, ...surface.componentProps, ...foundation.componentProps, ...rest, ref: ref, children: _jsx(ButtonContent, { size: foundation.componentProps.size, leftSlot: leftSlot, rightSlot: rightSlot, children: children }) }) }) }));
});
